import React, { Component } from 'react';

// Material UI Imports
import Avatar from '@material-ui/core/Avatar';

import withStyles from '@material-ui/core/styles/withStyles';
// Material Icons Imports
import IconComment from '@material-ui/icons/Comment';

// Components Imports
import AsyncImage from './AsyncImage';



import Card from '@material-ui/core/Card';
import CardHeader from "@material-ui/core/CardHeader";
import CardText from "@material-ui/core/CardContent";




const styles = theme =>({
  card: {
    marginTop: 10,
    marginBottom: 20,
  },
  cardPRC: {
    marginTop: 5,
    marginBottom: 10,
    boxShadow: "none",
  },
  header: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    title: {
      fontWeight: 400,
    },
    subtitle: {
      marginTop: 5,
      fontWeight: 400,
    },
  },
  text: {
    paddingTop: 0,
  },
  avatar: {
    backgroundColor: theme.palette.primary.main
  },
  root: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'flex-start',
    aling: 'left',
  },
  gridTile: {
    transform: 'rotate(90deg)',
    margin: '30px -20px'
  }
})


class ProjectLogEntry extends Component {

  render() {
    const { classes } = this.props;
    let event = new Date(Date.parse(this.props.ple.date))

    return (
      <Card className={classes.card}>
        <CardHeader
          title={this.props.ple.device.user.fullName}
          subheader= {event.toDateString() +" at "+event.getHours()+":"+event.getMinutes()+":"+event.getSeconds()}
          avatar={<Avatar className={classes.avatar}><IconComment /></Avatar>}
          className={classes.header}
        />
        <CardText className={classes.text}>

          <div>
            {this.props.ple.comment}
          </div>
          <br />
          <div className={classes.root}>

            {this.props.ple.images.map((tile, id) => (
              <div className={classes.gridTile} key={id}>
                <AsyncImage key={id} projectId={tile.project.id} imageId={tile.id} size="1000x1000" />
              </div>
            ))}

          </div>


        </CardText>
      </Card>
    )
  }

}
export default withStyles(styles)(ProjectLogEntry);



// WEBPACK FOOTER //
// src/components/innerComponents/ProjectLogEntry.js